import { render, staticRenderFns } from "./day_Num.vue?vue&type=template&id=1481c79d&scoped=true&"
import script from "./day_Num.vue?vue&type=script&lang=js&"
export * from "./day_Num.vue?vue&type=script&lang=js&"
import style0 from "./day_Num.vue?vue&type=style&index=0&id=1481c79d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1481c79d",
  null
  
)

component.options.__file = "day_Num.vue"
export default component.exports